import { OTA_Location } from "./ota_location.model";
import { OTA_OperatingCompany } from "./ota_operatingcompany.model";

export class OTA_ArrivalDetails {
    public transportationCode: string;
    public number: string;
    public arrivalLocation = new OTA_Location();
    public operatingCompany = new OTA_OperatingCompany();
}
